<template>
  <div>
    <div class="carrinho-container">
      <p class="titulo">RESUMO DA COMPRA</p>
      <div class="produtos" v-for="produto in carrinho" :key="produto.id">
        <div class="outer-div">
            <div :style="{'background': 'url(' + produto.Imagem + ')', 'background-size': 'cover'}" class="inner-div"></div>
        </div>
        <div class="produto">
          <h3>{{produto.ProdutoTitulo}}</h3>
          <span class="unidade">{{produto.Unidade.substring(8, 20)}} | {{produto.SemData === true ? 'Qualquer data' : new Date(criandoData(produto.DataOk['seconds']).toISOString()) | moment("ddd, DD/MM")}}</span>
          <span class="data-ok">{{produto.Horario}}</span>
          <span v-if="$store.state.menu.finalizacaoPedido != true" class="qtd">
            <span class="adicao" @click="removeUnidade(produto)">-</span>
            {{produto.Quantidade}} und
            <span class="subtracao" @click="adicionaUnidade(produto)">+</span></span>
          <span class="preco">{{produto.ValorUnitario | numeroPreco}}</span>
        </div>
        <div v-if="$store.state.menu.finalizacaoPedido != true" @click="excluirPromocao(produto.id, produto.Unidade, produto.Quantidade, $event)" class="lixeira">
          <i class="far fa-trash-alt"></i>
        </div>
          <span v-if="erroProduto === produto.id" class="msg-erro">{{mensagemErro}}</span>
      </div>

      <Cupom/>

      <div class="produtos">
        <div class="total">
          <p>TOTAL {{$store.state.carrinho.total | numeroPreco}}</p>
        </div>
      </div>

      <div v-if="$store.state.menu.finalizacaoPedido != true" class="finalizar">
          <button class="btn" @click="finalizarCompra()">FINALIZAR COMPRA</button>
      </div>
      <div v-if="$vssWidth < 1001 && $store.state.menu.finalizacaoPedido == true" class="finalizar">
        <button class="btn" @click="finalizarCompra()">FINALIZAR COMPRA</button>
      </div>

      <div class="continuar-compra">
        <a @click="handleOpenMenu">Continuar comprando</a>
      </div>
    </div>
  </div>
</template>

<script>
import { db, Timestamp } from '@/firebase.js'
import { mapActions } from 'vuex'
import VueScreenSize from 'vue-screen-size'
import axios from 'axios'
import Cupom from '../components/Cupom'

export default {
  name: 'Carrinho',
  mixins: [VueScreenSize.VueScreenSizeMixin],
  components: {
    db,
    Cupom
  },
  data: function () {
    return {
      carrinho: null,
      mensagemErro: '',
      erroProduto: false
    }
  },
  created () {
    this.getCarrinho()
    this.getTotal()
  },
  methods: {
    ...mapActions('menu', ['finalizacaoPedido', 'toggleMenu']),
    ...mapActions('carrinho', ['removerProduto', 'adicionarUnidadeProduto', 'removerUnidadeProduto', 'limparIdCarrinho', 'contadorProdutos', 'total']),
    ...mapActions('finalizarCompra', ['removerConfiguracoes']),
    cancelarPedidoAtualPicPay () {
      if (this.$store.state.finalizarCompra.qrCodePicPay != null || this.$store.state.finalizarCompra.urlPicPay) {
        axios({
          method: 'post',
          url: 'https://us-central1-loja-ilha-teste.cloudfunctions.net/cancelamentoPicPay',
          data: {
            referenceId: this.$store.state.finalizarCompra.idPedido
          }
        }).then(() => {
        }).catch(() => {
        })
      }
    },
    removeCarrinho () {
      db.collection('Carrinho').doc(this.$store.state.carrinho.idCarrinho).delete()
    },
    getTotal () {
      db.collection('Carrinho').doc(this.$store.state.carrinho.idCarrinho).onSnapshot((doc) => {
        if (doc.exists) {
          var totalAtual = 0
          for (var i in doc.data().ItensCarrinho) {
            totalAtual = totalAtual + (doc.data().ItensCarrinho[i].ValorUnitario * doc.data().ItensCarrinho[i].Quantidade)
          }
          this.total(totalAtual - this.$store.state.carrinho.cupomDesconto)
        }
      })
    },
    getCarrinho () {
      let loader = this.$loading.show({
        container: null,
        fullPage: true,
        color: '#F85E28',
        loader: 'spinner',
        width: 100,
        height: 100,
        backgroundColor: '#ffffff',
        opacity: 0.5,
        zIndex: 999
      })
      db.collection('Carrinho').doc(this.$store.state.carrinho.idCarrinho).onSnapshot((doc) => {
        if (doc.exists) {
          this.carrinho = doc.data().ItensCarrinho
        } else {
          this.carrinho = null
        }
      })
      loader.hide()
    },
    limparFinalizacaoPedido () {
      this.finalizacaoPedido(false)
      this.toggleMenu(false)
    },
    async adicionaUnidade (produto) {
      if (produto.Quantidade < parseInt(produto.QtdUnidades) && produto.Quantidade + produto.QtdComprada < produto.QtdMaxCliente) {
        this.cancelarPedidoAtualPicPay()
        this.removerConfiguracoes()
        db.collection('Promocoes').doc(produto.id.replace(produto.Unidade, '').replace(' ', '')).get().then((doc) => {
          var mapa = doc.data().QtdUnidadesReserva
          mapa[produto.Unidade] = parseInt(doc.data().QtdUnidadesReserva[produto.Unidade]) + 1
          db.collection('Promocoes').doc(produto.id.replace(produto.Unidade, '').replace(' ', '')).update({
            'QtdUnidadesReserva': mapa
          })
        })
        this.carrinho[produto.id].Quantidade = this.carrinho[produto.id].Quantidade + 1
        db.collection('Carrinho').doc(this.$store.state.carrinho.idCarrinho).update({
          ItensCarrinho: this.carrinho
        })
        this.erroProduto = null
      } else {
        this.erroProduto = produto.id
        this.mensagemErro = 'Quantidade máxima por cliente atingida'
        // eslint-disable-next-line no-return-assign
        setTimeout(() => this.erroProduto = null, 5000)
      }
    },
    removeUnidade (produto) {
      if (produto.Quantidade > 1) {
        this.cancelarPedidoAtualPicPay()
        this.removerConfiguracoes()
        db.collection('Promocoes').doc(produto.id.replace(produto.Unidade, '').replace(' ', '')).get().then((doc) => {
          var mapa = doc.data().QtdUnidadesReserva
          mapa[produto.Unidade] = parseInt(doc.data().QtdUnidadesReserva[produto.Unidade]) - 1
          db.collection('Promocoes').doc(produto.id.replace(produto.Unidade, '').replace(' ', '')).update({
            'QtdUnidadesReserva': mapa
          })
        })
        this.carrinho[produto.id].Quantidade = this.carrinho[produto.id].Quantidade - 1
        db.collection('Carrinho').doc(this.$store.state.carrinho.idCarrinho).update({
          ItensCarrinho: this.carrinho
        })
      }
    },
    async excluirPromocao (id, unidade, quantidade, e) {
      this.cancelarPedidoAtualPicPay()
      this.removerConfiguracoes()
      await db.collection('Promocoes').doc(id.replace(unidade, '').replace(' ', '')).get().then((doc) => {
        var mapa = doc.data().QtdUnidadesReserva
        mapa[unidade] = doc.data().QtdUnidadesReserva[unidade] - quantidade
        db.collection('Promocoes').doc(id.replace(unidade, '').replace(' ', '')).update({
          'QtdUnidadesReserva': mapa
        })
      })
      db.collection('Carrinho').doc(this.$store.state.carrinho.idCarrinho).get().then((doc) => {
        var itensCarrinho = doc.data().ItensCarrinho
        delete itensCarrinho[id]
        db.collection('Carrinho').doc(this.$store.state.carrinho.idCarrinho).update({
          ItensCarrinho: itensCarrinho
        })
        this.contadorProdutos(this.$store.state.carrinho.contador - 1)
        var len = 0
        // eslint-disable-next-line no-unused-vars
        for (var i in itensCarrinho) {
          len = len + 1
        }
        if (len === 0) {
          this.removeCarrinho()
          this.limparIdCarrinho()
          this.toggleMenu(false)
        }
      })
    },
    criandoData (seconds) {
      var t = new Date(1970, 0, 1)
      t.setSeconds(seconds)
      return t
    },
    finalizarCompra (documento) {
      this.finalizacaoPedido(true)
      var d = new Date()
      d.setMinutes(d.getMinutes() + 8)
      var timeStamp = Timestamp.fromDate(d)
      db.collection('Carrinho').doc(this.$store.state.carrinho.idCarrinho).update({
        'DataExpiracao': timeStamp
      })
      this.$fire({
        title: 'Regras da Promoção',
        html: '<p style="font-size: 0.9rem; text-align: left">O cliente deverá apresentar o nome completo ou o QR Code para realizar o consumo.' +
           ' As promoções valem somente para as datas, horários e unidades citados previamente.<br/><br/>' +
          'A taxa de serviço (10%) é opcional e poderá ser cobrada sobre o valor original' +
           ' ou promocional do cupom, seguindo a lei vigente. Imagens meramente ilustrativas.<br/><br/>' +
           ' Em casos de impossibilidade do cliente comparecer no dia da promoção, ' +
           'a não utilização do voucher acarretará em uma cobrança administrativa de 10% (dez por cento) e o cliente deverá solicitar seu estorno diretamente com o Ilha do Caranguejo.<br/><br/>' +
           'O Ilha do Caranguejo reconhece a aplicação integral do Código de Defesa do Consumidor (Lei No. 8.078, de 11 de setembro de 1990),' +
           ' bem como o Decreto no 7.962/13, que dispõe sobre a contratação no comércio eletrônico, em favor de seus clientes, e tem como foco principal o cumprimento dessas regras.<br/><br/>' +
            'Caso tenha interesse em saber mais sobre seus direitos e como executá-los,' +
            ' recomendamos a leitura dessa lei, acessando este link: http://www.planalto.gov.br/ccivil_03/leis/L8078.htm ou através do site oficial do governo brasileiro, ao site www.planalto.gov.br',
        type: 'info'
      }).then(r => {
        console.log(r.value)
      })
      if (this.$store.state.usuario.usuario == null) {
        this.$router.push({name: 'Login'})
      } else {
        this.$router.push({name: 'Pagamento', params: {id: this.$store.state.carrinho.idCarrinho}})
      }
    },
    ...mapActions('menu', ['toggleMenu']),
    handleOpenMenu (e) {
      if (this.$store.state.carrinho.produtos.length > 0) {
        e.preventDefault()
        e.stopPropagation()
        this.toggleMenu(!this.$store.state.menu.aberto)
      }
      this.continuarCompra()
    },
    continuarCompra (documento) {
      this.finalizacaoPedido(false)
      this.toggleMenu(false)
      if (window.location.pathname !== '/') {
        this.$router.push({name: 'HomePage'})
      }
    }
  }
}
</script>

<style scoped>
.carrinho-container {
  max-width: 330px;
  margin: 0 0 0 -20px;
  display: grid;
  grid-template-columns: 1fr;
}

button {
  color: #fff;
  padding: 10px 20px;
  border-radius: 4px;
  border: 0;
  font-size: 1.05em;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(30, 60, 90, 0.2);
  transition: all 0.3s;
}

button:hover {
  transform: scale(1.1);
}

.bt-cupom {
  background: #2E9189;
}

.bt-cupom:hover {
  background: #186B65;
}

.msg-erro{
  grid-column: span 3;
  margin: 0 auto;
  font-size: 0.8rem;
  color: #FF0000;
}

.titulo {
  font-size: 1.2rem;
  color: #2E9189;
  font-weight: 600;
  border-bottom: 1px solid #2E9189;
  padding: 5px 0;
  margin: 0 0 15px 0;
}

.produtos {
  display: grid;
  grid-template-columns: 100px 1fr 20px;
  padding: 15px 0;
  justify-items: start;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid #f3f3f3;
  color: #333;
}

.produtos h3 {
  color: #F85E28;
  font-size: 0.95rem;
  text-align: left;
  margin: 0;
}

.total {
  grid-column: span 3;
}

.data {
  padding: 5px;
}

.data-ok {
  text-align: left;
}

.outer-div {
  width: 110px;
  height: 110px;
  overflow: hidden;
  box-shadow: 5px 5px 15px 0px rgba(44, 44, 44, 0.15);
  margin: 8px 0 12px -10px;
}

.inner-div {
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: center;
  transition: all 0.7s ease;
}

.inner-div:hover {
  transform: scale(1.1);
}

.produto {
  display: grid;
  justify-items: start;
}

.lixeira {
  color: #bdbcb3;
  cursor: pointer;
}

.lixeira:hover {
  color: #978A3B;
}

.qtd, .preco, .unidade {
  font-weight: 600;
}

.produto span {
  font-size: 0.9rem;
}

.unidade {
  text-align: left;
  font-size: 0.85rem !important;
}

.qtd {
  margin: 8px 0;
  background: #f3f3f3;
  padding: 5px 0;
  cursor: pointer;
}

.subtotal {
  font-weight: 600;
}

.total {
  font-weight: 700;
  font-size: 1.2em;
  justify-self: center;
}

.finalizar {
  margin: 25px auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.finalizar button {
  margin: 10px auto;
}

.continuar-compra {
  color: #F85E28;
  font-size: 1rem;
  font-weight: 500;
  margin: 20px 0;
}

.adicao {
  padding: 0 10px;
}

.subtracao {
  padding: 0 10px;
}

</style>



// WEBPACK FOOTER //
// src/views/Carrinho.vue